"use strict";
/* Generated from:
 * ap-northeast-1 (https://d33vqc0rt9ld30.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-northeast-2 (https://d1ane3fvebulky.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-northeast-3 (https://d2zq80gdmjim8k.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-south-1 (https://d2senuesg1djtx.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-southeast-1 (https://doigdx0kgq9el.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-southeast-2 (https://d2stg8d246z9di.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ca-central-1 (https://d2s8ygphhesbe7.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-central-1 (https://d1mta8qj7i28i2.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-1 (https://d3teyb21fexa9r.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-2 (https://d1742qcu2c1ncx.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-3 (https://d2d0mfegowb3wk.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * sa-east-1 (https://d3c9jyj3w509b0.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-1 (https://d1uauaxba7bl26.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-2 (https://dnwj8swjjbsbt.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-west-1 (https://d68hl49wbnanq.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-west-2 (https://d201a2mn26r7lk.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
const resource_1 = require("../resource");
class ComputeLimits {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ComputeLimits = ComputeLimits;
class SpotProvisioningSpecification {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SpotProvisioningSpecification = SpotProvisioningSpecification;
class BootstrapActionConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.BootstrapActionConfig = BootstrapActionConfig;
class StepConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.StepConfig = StepConfig;
class EbsBlockDeviceConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.EbsBlockDeviceConfig = EbsBlockDeviceConfig;
class ManagedScalingPolicy {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ManagedScalingPolicy = ManagedScalingPolicy;
class CloudWatchAlarmDefinition {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.CloudWatchAlarmDefinition = CloudWatchAlarmDefinition;
class KeyValue {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.KeyValue = KeyValue;
class VolumeSpecification {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VolumeSpecification = VolumeSpecification;
class InstanceFleetProvisioningSpecifications {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.InstanceFleetProvisioningSpecifications = InstanceFleetProvisioningSpecifications;
class InstanceGroupConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.InstanceGroupConfig = InstanceGroupConfig;
class KerberosAttributes {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.KerberosAttributes = KerberosAttributes;
class Application {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Application = Application;
class Configuration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Configuration = Configuration;
class ScriptBootstrapActionConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ScriptBootstrapActionConfig = ScriptBootstrapActionConfig;
class EbsConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.EbsConfiguration = EbsConfiguration;
class InstanceTypeConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.InstanceTypeConfig = InstanceTypeConfig;
class MetricDimension {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.MetricDimension = MetricDimension;
class OnDemandProvisioningSpecification {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.OnDemandProvisioningSpecification = OnDemandProvisioningSpecification;
class ScalingTrigger {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ScalingTrigger = ScalingTrigger;
class InstanceFleetConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.InstanceFleetConfig = InstanceFleetConfig;
class JobFlowInstancesConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.JobFlowInstancesConfig = JobFlowInstancesConfig;
class ScalingConstraints {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ScalingConstraints = ScalingConstraints;
class ScalingAction {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ScalingAction = ScalingAction;
class SimpleScalingPolicyConfiguration {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SimpleScalingPolicyConfiguration = SimpleScalingPolicyConfiguration;
class PlacementType {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.PlacementType = PlacementType;
class ScalingRule {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ScalingRule = ScalingRule;
class AutoScalingPolicy {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AutoScalingPolicy = AutoScalingPolicy;
class HadoopJarStepConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.HadoopJarStepConfig = HadoopJarStepConfig;
class Cluster extends resource_1.ResourceBase {
    constructor(properties) {
        super('AWS::EMR::Cluster', properties);
    }
}
exports.default = Cluster;
Cluster.ComputeLimits = ComputeLimits;
Cluster.SpotProvisioningSpecification = SpotProvisioningSpecification;
Cluster.BootstrapActionConfig = BootstrapActionConfig;
Cluster.StepConfig = StepConfig;
Cluster.EbsBlockDeviceConfig = EbsBlockDeviceConfig;
Cluster.ManagedScalingPolicy = ManagedScalingPolicy;
Cluster.CloudWatchAlarmDefinition = CloudWatchAlarmDefinition;
Cluster.KeyValue = KeyValue;
Cluster.VolumeSpecification = VolumeSpecification;
Cluster.InstanceFleetProvisioningSpecifications = InstanceFleetProvisioningSpecifications;
Cluster.InstanceGroupConfig = InstanceGroupConfig;
Cluster.KerberosAttributes = KerberosAttributes;
Cluster.Application = Application;
Cluster.Configuration = Configuration;
Cluster.ScriptBootstrapActionConfig = ScriptBootstrapActionConfig;
Cluster.EbsConfiguration = EbsConfiguration;
Cluster.InstanceTypeConfig = InstanceTypeConfig;
Cluster.MetricDimension = MetricDimension;
Cluster.OnDemandProvisioningSpecification = OnDemandProvisioningSpecification;
Cluster.ScalingTrigger = ScalingTrigger;
Cluster.InstanceFleetConfig = InstanceFleetConfig;
Cluster.JobFlowInstancesConfig = JobFlowInstancesConfig;
Cluster.ScalingConstraints = ScalingConstraints;
Cluster.ScalingAction = ScalingAction;
Cluster.SimpleScalingPolicyConfiguration = SimpleScalingPolicyConfiguration;
Cluster.PlacementType = PlacementType;
Cluster.ScalingRule = ScalingRule;
Cluster.AutoScalingPolicy = AutoScalingPolicy;
Cluster.HadoopJarStepConfig = HadoopJarStepConfig;
